export const getThemeColors = (isDark: boolean) => ({
  // Background colors - matching webapp CSS variables
  background: isDark ? '#020817' : '#FFFFFF', // dark: --background, light: white
  surface: isDark ? '#0F172A' : '#FFFFFF', // dark: --card, light: white
  surfaceSecondary: isDark ? '#1E293B' : '#F8FAFC', // dark: --secondary, light: gray-50
  
  // Text colors - matching webapp CSS variables
  textPrimary: isDark ? '#F8FAFC' : '#0F172A', // dark: --foreground, light: --foreground
  textSecondary: isDark ? '#CBD5E1' : '#475569', // dark: --muted-foreground, light: --muted-foreground
  textTertiary: isDark ? '#94A3B8' : '#64748B', // dark: muted variant, light: muted variant
  
  // Border colors - matching webapp CSS variables
  border: isDark ? '#334155' : '#E2E8F0', // dark: --border, light: --border
  borderSecondary: isDark ? '#475569' : '#CBD5E1', // dark: border variant, light: border variant
  
  // Accent colors - matching webapp CSS variables
  primary: isDark ? '#3B82F6' : '#3B82F6', // blue-500
  primaryLight: isDark ? '#60A5FA' : '#60A5FA', // blue-400
  secondary: isDark ? '#8B5CF6' : '#8B5CF6', // violet-500
  success: isDark ? '#10B981' : '#10B981', // emerald-500
  warning: isDark ? '#F59E0B' : '#F59E0B', // amber-500
  info: isDark ? '#3B82F6' : '#3B82F6', // blue-500
  error: isDark ? '#EF4444' : '#EF4444', // red-500
  
  // Status colors
  unreadBackground: isDark ? '#1E3A8A' : '#F0F9FF', // blue-900/blue-50
  unreadBorder: isDark ? '#3B82F6' : '#3B82F6', // blue-500
  
  // Tab colors
  tabActive: isDark ? '#FFFFFF' : '#3B82F6', // dark: white, light: blue-500
  tabInactive: isDark ? '#94A3B8' : '#64748B', // dark: light gray, light: slate-500
  tabBackground: isDark ? '#000000' : '#FFFFFF', // dark: black, light: white
  tabActiveBackground: isDark ? '#475569' : '#F1F5F9', // dark: gray, light: slate-100
  
  // Card colors
  cardBackground: isDark ? '#0F172A' : '#FFFFFF', // dark: --card, light: white
  cardShadow: isDark ? '#000000' : '#000000', // shadow color
  
  // Input colors
  inputBackground: isDark ? '#1E293B' : '#FFFFFF', // dark: --secondary, light: white
  inputBorder: isDark ? '#475569' : '#CBD5E1', // dark: border variant, light: border variant
  inputText: isDark ? '#F8FAFC' : '#0F172A', // dark: --foreground, light: --foreground
  inputPlaceholder: isDark ? '#94A3B8' : '#64748B', // dark: muted variant, light: muted variant
  
  // Badge colors
  badgeBackground: isDark ? '#EF4444' : '#EF4444', // red-500
  badgeText: isDark ? '#FFFFFF' : '#FFFFFF', // white
  
  // Icon colors - properly inverted for dark mode
  iconPrimary: isDark ? '#F8FAFC' : '#0F172A', // dark: white, light: black
  iconSecondary: isDark ? '#CBD5E1' : '#475569', // dark: light gray, light: dark gray
  
  // Action button colors for dark mode
  actionButtonBackground: isDark ? '#000000' : '#F8FAFC', // dark: black, light: gray-50
  actionButtonText: isDark ? '#FFFFFF' : '#0F172A', // dark: white, light: black
  
  // Overlay colors
  overlay: isDark ? 'rgba(0, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0.5)', // same for both
  
  // Special colors for notifications - matching webapp colors
  notificationColors: {
    chapter: isDark ? '#A78BFA' : '#6366F1', // purple-400/indigo-500
    chat: isDark ? '#60A5FA' : '#3B82F6', // blue-400/blue-500
    quiz: isDark ? '#34D399' : '#10B981', // emerald-400/emerald-500
    card: isDark ? '#C084FC' : '#8B5CF6', // purple-400/violet-500
    badge: isDark ? '#FBBF24' : '#F59E0B', // amber-400/amber-500
    leaderboard: isDark ? '#FB923C' : '#F97316', // orange-400/orange-500
    mission: isDark ? '#FBBF24' : '#F59E0B', // amber-400/amber-500
    system: isDark ? '#94A3B8' : '#64748B', // slate-400/slate-500
  },
  
  // Additional colors for better dark mode support
  destructive: isDark ? '#EF4444' : '#EF4444', // red-500
  destructiveForeground: isDark ? '#F8FAFC' : '#FFFFFF', // dark: white, light: white
  
  // Muted colors for better contrast
  muted: isDark ? '#1E293B' : '#F8FAFC', // dark: --muted, light: --muted
  mutedForeground: isDark ? '#94A3B8' : '#64748B', // dark: --muted-foreground, light: --muted-foreground
  
  // Accent colors
  accent: isDark ? '#1E293B' : '#F1F5F9', // dark: --accent, light: --accent
  accentForeground: isDark ? '#F8FAFC' : '#0F172A', // dark: --accent-foreground, light: --accent-foreground
  
  // Popover colors
  popover: isDark ? '#0F172A' : '#FFFFFF', // dark: --popover, light: --popover
  popoverForeground: isDark ? '#F8FAFC' : '#0F172A', // dark: --popover-foreground, light: --popover-foreground
  
  // Ring colors for focus states
  ring: isDark ? '#3B82F6' : '#3B82F6', // blue-500 for both
}); 
